import React from 'react';
import trackEvent, { ANALYTICS_EVENTS } from '../utilities/analytics';
import { ErrorTracking } from '../config';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, { componentStack }) {
    ErrorTracking.critical('Crash while rendering component', error);
    trackEvent({
      type: ANALYTICS_EVENTS.INIT,
      createdAt: window.globalConfig.createdAt,
      status: 'Failed',
      error: error.toString(),
    });
  }

  render() {
    if (this.state.hasError) {
      return <span>An error occurred.</span>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
